const wordsData = [
    {
        "lang": "English",
        "words": [
            "Time",
            "Person",
            "Year",
            "Way",
            "Day",
            "Thing",
            "Man",
            "World",
            "Life",
            "Child",
            "Eye",
            "Woman",
            "Place",
            "Work",
            "Week",
            "Case",
            "Point",
            "Government",
            "Company",
            "Number",
            "Group",
            "Fact"
        ]
    },
    {
        "lang": "Spanish",
        "words": [
            "Vez",
            "Ocasion",
            "Año",
            "País",
            "Tiempo",
            "Lugar",
            "Día",
            "Persona",
            "Hora",
            "Hombre",
            "Trabajo",
            "Vida",
            "Manera",
            "Forma",
            "Fin",
            "Tipo",
            "Mundo",
            "Gente",
            "Mujer"
        ]
    },
    {
        "lang": "French",
        "words": [
            "Être",
            "Moins",
            "Avoir",
            "Temps",
            "Pas",
            "Savoir",
            "Pouvoir",
            "Raison",
            "Non",
            "Dire",
            "An",
            "Devoir",
            "Monde",
            "Avant",
            "Jour",
            "Deux",
            "Monsieur",
            "Personne",
            "Fois",
            "Nouveau",
            "Pendant",
            "Vouloir"
        ]
    },
    {
        "lang": "German",
        "words": [
            "Jahr",
            "Leute",
            "Arbeit",
            "Beispiel",
            "Prozent",
            "Zeit",
            "Frau",
            "Stadt",
            "Mensch",
            "Herr",
            "Teil",
            "Tag",
            "Mann",
            "Welt",
            "Recht",
            "Frage",
            "Ende",
            "Haus",
        ]
    },
    {
        "lang": "Italian",
        "words": [
            "Anno",
            "Uomo",
            "Giorno",
            "Volta",
            "Vita",
            "Donna",
            "Occhio",
            "Ora",
            "Signore",
            "Paese",
            "Parola",
            "Lavoro",
            "Stato",
            "Città",
            "Animale"
        ]
    },
    {
        "lang": "Portuguese",
        "words": [
            "Moça",
            "Jeito",
            "Coisa",
            "Homem",
            "Palavra",
            "Mão",
            "Criança",
            "Olho",
            "Mulher",
            "Trabalho",
            "Moço",
            "Senhor",
            "Cabeça"
        ]
    },
    {
        "lang": "Dutch",
        "words": [
            "Jaar",
            "Seconde",
            "Uur",
            "Minuut",
            "Koffie",
            "Ijs",
            "Thee",
            "Moeder",
            "Vader",
            "Echtgenoot",
            "Vrouw",
            "Zoon",
            "Dochter",
            "Vis"
        ]
    },
    {
        "lang": "Russian",
        "words": [
            "Человек",
            "Год",
            "Время",
            "Имя",
            "Раз",
            "Деньги",
            "Жизнь",
            "День",
            "Голова",
            "Друг",
            "Дом",
            "Слово",
            "Место",
            "Лицо",
            "Неделя",
            "Нога",
            "Мать",
            "Отец",
            "Месяц",
            "Час",
            "Сестра",
            "Брат",
            "Вода",
            "Сумка"
        ]
    },
    {
        "lang": "Greek",
        "words": [
            "Ελπίδα",
            "Χαρμολύπη",
            "Φιλοξενία",
            "Υγεία",
            "Ψυχή",
            "Ίριδα",
            "Ευτυχία",
            "Αιώνια",
            "Αγάπη",
            "Μεράκι",
            "Νοσταλγία",
            "Φιλότιμο",
            "Χαλαρά",
            "Πετριχώρ",
            "Ελευθερία"
        ]
    }
];

export default wordsData;